document.addEventListener("DOMContentLoaded", () => {
  // Initialize modal slider for all screen sizes
  const modalSlider = new Swiper("#ModalSlider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  const mainHeader = document.querySelector('.ed-header');
  const productInfo = document.querySelector('.main-product .info-wrapper');

  function updateProductInfoPosition() {
      if (window.innerWidth >= 990 && mainHeader && productInfo) {
          const mainHeaderHeight = mainHeader.offsetHeight;
          productInfo.style.top = mainHeaderHeight + 'px';
      } else if (productInfo) {
          productInfo.style.top = ''; // Reset style when under 990px
      }
  }

  // Run on page load
  window.addEventListener('DOMContentLoaded', updateProductInfoPosition);

  // Run on scroll
  window.addEventListener('scroll', updateProductInfoPosition);

  // Run on window resize (to check if width crosses 990px)
  window.addEventListener('resize', updateProductInfoPosition);
});


(function(history) {
  const pushState = history.pushState;
  const replaceState = history.replaceState;

  function urlChangeHandler() {
    setTimeout(() => { // Wacht even om de DOM bij te werken

      // Haal de waarde van data-sale-percentage op
      const salePercentageElement = document.getElementById('salePercentage');
      const saleLabelElement = document.getElementById('saleLabel');
      const newLabelElement = document.getElementById('newLabel');

      if (salePercentageElement) {
        const salePercentage = salePercentageElement.getAttribute('data-sale-percentage');

        // Plaats de waarde in de saleLabel div
        if (saleLabelElement) {
          saleLabelElement.textContent = salePercentage ? `${salePercentage}% OFF` : '';
          if (newLabelElement) {
            if (salePercentage) {
              newLabelElement.style.display = 'none';
            } else {
              newLabelElement.classList.remove('hidden');
              newLabelElement.style.display = 'block';
            }
          }
        }

      }
    }, 100); // Kleine vertraging (100ms) om de DOM te laten updaten
  }

  history.pushState = function() {
    pushState.apply(history, arguments);
    urlChangeHandler();
  };

  history.replaceState = function() {
    replaceState.apply(history, arguments);
    urlChangeHandler();
  };

  window.addEventListener('popstate', urlChangeHandler);

  // Roep de functie direct aan bij pageload
  document.addEventListener("DOMContentLoaded", urlChangeHandler);
})(window.history);


// Get height of main image
function updateMediaGalleryHeight() {
  const mainImage = document.getElementById("MainImage");
  const mediaGallery = document.querySelector("media-gallery");

  if (mainImage && mediaGallery) {
    const imageHeight = mainImage.clientHeight;
    mediaGallery.style.maxHeight = imageHeight + "px";
  }
}

// Voer uit bij laden en bij resizen van het scherm
document.addEventListener("DOMContentLoaded", updateMediaGalleryHeight);
window.addEventListener("resize", updateMediaGalleryHeight);

